import React from "react";
import { ReactDataGrid } from "rhombus-react";
import classNames from "classnames";

const { Row } = ReactDataGrid;

export default function DisabledDTreeRow(props){
	let { isDisabled } = props.row;
	let extraClasses = isDisabled ? "disabled" : "";
	return <Row extraClasses={extraClasses} {...props} />;
}

export class DisabledDTreeRowRenderer extends React.Component {

	setScrollLeft = (scrollBy) => {
		this.row.setScrollLeft(scrollBy);
	}

	render() {
		// using my custom row
		const { assignable, assigned } = this.props.row
		 , shouldDisable =   !assignable || (!assigned && !assignable)
		 , extraClasses = classNames({ disabled:shouldDisable });

		 return 	<Row ref={node => this.row = node} {...this.props} extraClasses={extraClasses} />;
	}

}
